import React from 'react';
import styled from 'styled-components';

import { WEB_APP_SIGNUP_URL } from '../../../globals';
import { PrimaryButtonLink } from '../../button';
import Plan from './Plan';
import PlanBenefits from './PlanBenefits';
import PlanTerms from './PlanTerms';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const PlansContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  position: relative;
  a {
    font-size: 12px;
  }
`;

export interface Prices {
  monthly: string;
  yearly: string;
}

export interface PricingProps {
  price: Prices;
  isLocalized: boolean;
  currency?: string;
}

export const Plans: React.FC<PricingProps> = props => {
  const { price } = props;

  return (
    <Container>
      <PlanBenefits />
      <PlansContainer>
        <Plan
          description="Unlimited access to Brain.fm for a month"
          duration="month"
          price={price.monthly}
          subDescription={`Then ${price.monthly} billed monthly. Cancel anytime.`}
          title="Monthly plan"
          trialInfo="7-Day Free Trial"
        >
          <ButtonWrapper>
            <PrimaryButtonLink
              analyticsEvent={{ category: 'Plans Page', action: 'Get Monthly Subscription Click' }}
              href={WEB_APP_SIGNUP_URL}
            >
              START 7-DAY FREE TRIAL
            </PrimaryButtonLink>
          </ButtonWrapper>
        </Plan>

        <Plan
          description="Unlimited access to Brain.fm for 12 months"
          duration="year"
          popular
          price={price.yearly}
          subDescription={`Then ${price.yearly} billed annually. Cancel anytime.`}
          title="Yearly plan"
          trialInfo="14-Day Free Trial"
        >
          <ButtonWrapper>
            <PrimaryButtonLink
              analyticsEvent={{ category: 'Plans Page', action: 'Get Year Subscription Click' }}
              href={WEB_APP_SIGNUP_URL}
            >
              START 14-DAY FREE TRIAL
            </PrimaryButtonLink>
          </ButtonWrapper>
        </Plan>
      </PlansContainer>

      <PlanTerms />
    </Container>
  );
};
